// Stamped by scripts/write-release.mjs when GITHUB_SHA or .preview-client-id is
// present. These committed values are the local and unit-test defaults.
// releaseVersion matches the Datadog sourcemap upload (`github.sha`).
// previewClientId is the ephemeral Sirius client for a PR preview.
export const releaseVersion = '9959275c121b77d0d9d9c2b1bc169c7f6f906538';
export const previewClientId = 'future-room-preview-future-room-5-m3h7mlnq';
